import { useThemeContext } from "../../context/ThemeContext";
import { content } from "../../data/content";

import styles from "./Hero.module.scss";

export function Hero() {
  const theme = useThemeContext();
  const c = content;

  return (
    <section className={styles.hero}>
      <div className={styles.breadcrumb} style={{ color: theme.muted }}>
        <span style={{ color: theme.acc }}>~/</span>
        <span>michelle</span>
        <span style={{ opacity: 0.4 }}>/</span>
        <span>readme.md</span>
      </div>
      <h1 className={styles.h1}>
        hi, i'm{" "}
        <span
          style={{
            background: `linear-gradient(180deg, transparent 64%, ${theme.acc}40 64%, ${theme.acc}40 92%, transparent 92%)`,
            padding: "0 4px",
          }}
        >
          michelle
        </span>{" "}
        —{" "}
        <span className={styles.orbWrapper}>
          <span className={styles.orb} style={{ background: theme.moss }} />
        </span>
        <br />a junior frontend dev who likes{" "}
        <span style={{ color: theme.acc, fontStyle: "italic" }}>
          the boring web
        </span>
        .
      </h1>
      <p className={styles.intro} style={{ color: theme.muted }}>
        {c.intro[0]} <span style={{ color: theme.fg }}>{c.intro[1]}</span>
      </p>
    </section>
  );
}
